export var AgentState;
(function (AgentState) {
    AgentState["Active"] = "Active";
    AgentState["Archived"] = "Archived";
})(AgentState || (AgentState = {}));
//# sourceMappingURL=agent-state.const.js.map